import { RootState } from 'dashboard/redux/store';

export function isPersonerd(state: RootState): boolean {
  return (
    !!state.currentUser.impersonationMode ||
    !!state.currentUser.currentUser?.attributes?.['email-address']?.endsWith('@withpersona.com')
  );
}
